import { Button } from '@/components/button';
import { Section } from '@/components/containers/section';
import { UserEntryLayout } from '@/components/auth/user-entry-layout';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './missing-email-page.module.css';
import { Envelope } from '@/components/svgs/envelope';

export function MissingEmailPage() {
  const { t } = useTranslation();

  return (
    <UserEntryLayout>
      <Section className={styles.section} isFormSection={false}>
        <Envelope className={styles.icon} />
        <div className={styles.content}>
          <h1 className="h3">{t('missingEmail.title')}</h1>
          <p className={styles.description}>{t('missingEmail.description')}</p>
        </div>
        <Button as="a" to="/support" fullWidth>
          {t('missingEmail.contactSupport')}
        </Button>
      </Section>
    </UserEntryLayout>
  );
}
